import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import { Button } from 'react-bootstrap'

import ProductItem from 'components/ProductList/Item'
import { useShowMore } from 'hooks/useShowMore'
import type { Fields as Product } from 'models/Product'

const t = buildTranslate('redeem_manager.detail.cards.online_redemption')

type ProductItemsProps = {
  products: Product[]
  deleteItem: (uid: string) => void
  zeroPricedProductIds?: Set<string>
}

const ProductItems = ({
  products,
  deleteItem,
  zeroPricedProductIds,
}: ProductItemsProps) => {
  const reversedProducts = [...products].reverse()
  const { visibleItems, hiddenCount, hasHidableItems, toggleShowAll, showAll } =
    useShowMore(reversedProducts)
  const handleDelete = id => () => deleteItem(id)

  return (
    <div>
      {visibleItems.map(product => (
        <ProductItem
          key={product.chain_uid}
          product={product}
          displayDeleteIcon
          onDelete={handleDelete(product.chain_uid)}
          warningTooltip={
            zeroPricedProductIds?.has(product.chain_uid)
              ? t('zero_price_item_warning')
              : undefined
          }
        />
      ))}
      <Switch condition={hasHidableItems}>
        <Button
          bsStyle="link"
          type="button"
          onClick={toggleShowAll}
          className="p-0 m-0"
        >
          {showAll ? t('show_less') : t('show_more', { count: hiddenCount })}
        </Button>
      </Switch>
    </div>
  )
}

export default ProductItems
